<div class="tab-pane fade active show" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">
  <div class="card">
    <div class="card-header">
      <button class="btn btn-light collapse-toggle btn-sm" data-toggle="collapse"
        data-target="#id-content-collapse" aria-expanded="true" aria-controls="id-content-collapse">
        <span class="collapse-icon"></span>
      </button>Identifications
      <button type="button" class="btn btn-sm btn-primary float-right" data-toggle="modal"
        data-target="#addIdentificationsModal" (click)="reset()" title="Add" [disabled]="contactId == 0">
        Add
      </button>
    </div>
    <div class="collapse show" id="id-content-collapse">
      <div class="card-body">
        <div class="row text-dark">
          @if (isFlat && !identificationUpdate) {
            <section class="col-12">
              <form [formGroup]="form" class="text-dark">
                <ng-container formArrayName="ids">
                  @for (identityForm of ids.controls; track identityForm; let i = $index) {
                    <div>
                      <div class="row mx-0" [formGroup]="identityForm">
                        <!-- type input-->
                        <div class="form-group col-md-3" [ngClass]="{'col-md-6': isFlat}">
                          <label for="type">{{ words[language][ 'type' ] }}</label>
                          <select class="form-control form-control-sm" formControlName="identificationTypeId">
                            @for (type of identificationTypes; track type.id) {
                            <option value="{{type.id}}">{{type.type}}</option>
                            }
                          </select>
                        </div>
                        <!-- number input -->
                        <div class="form-group col-md-3" [ngClass]="{'col-md-6': isFlat}">
                          <label for="number">{{ words[language][ 'number' ] }}</label>
                          <input class="form-control" type="number" id="number"
                            formControlName="number" autocomplete="off">
                          @if (identityForm.get('number').invalid && identityForm.get('number').dirty) {
                            <span class="text-danger"
                              >{{
                            words[language][ 'invalidNumber' ] }}</span>
                          }
                        </div>
                        <!--  Issuer  input -->
                        <div class="form-group col-md-2" [ngClass]="{'col-md-6': isFlat}">
                          <label for="issuer">{{ words[language][ 'issuer' ] }}</label>
                          <select id="issuer" class="form-control" formControlName="issuer">
                            @for (object of issuers; track object) {
                              <option [value]="object.name">
                              {{object.name}}</option>
                            }
                          </select>
                          @if (identityForm.get('issuer').invalid && identityForm.get('issuer').dirty) {
                            <span class="text-danger"
                              >{{
                            words[language][ 'invalidIssuer' ] }}</span>
                          }
                        </div>
                        <!--  Expiration Date input -->
                        <div class="form-group col-md-3 col-sm-11" [ngClass]="{'col-md-6': isFlat}">
                          <label for="expiration">{{ words[language][ 'expirationDate' ] }}</label>
                          <input class="form-control" type="date" max="3000-12-31" id="expiration"
                            formControlName="expirationDate" autocomplete="off">
                          @if (identityForm.get('expirationDate').invalid && identityForm.get('expirationDate').dirty) {
                            <span class="text-danger"
                              >{{
                            words[language][ 'invalidExpirationDate' ] }}</span>
                          }
                        </div>
                        <!-- icons -->
                        <div class="col-sm-1 d-flex align-items-center justify-content-center"
                          [ngClass]="{'col-md-12': isFlat}">
                          <!-- discard -->
                          @if ((ids.length > 0) && !loading) {
                            <button type="button"
                            class="btn btn-warning btn-sm" (click)="discard(i)">Remove</button>
                          }
                        </div>
                      </div>
                    </div>
                  }
                  <button type="button" class="btn btn-success btn-sm" (click)="add($event)" id="addIdentity"><span
                  class="dripicons-plus"></span> {{words[language].addAnother}}</button>
                </ng-container>
                <!--  -->
                <div class="col-sm-12 d-flex align-items-center justify-content-center">
                  <button class="btn btn-success" id="btn-save-identifications-new" (click)="save()"
                    [class.d-none]="isFlat" [disabled]="loading || form.invalid">
                    @if (loading) {
                      <span class="spinner-grow spinner-grow-sm mr-1" role="status"
                      ></span>
                    }
                  {{ words[language][ 'save' ] }}</button>
                </div>
              </form>
            </section>
          }
          @if (isFlat && identificationUpdate) {
            <section class="col-12">
              <form [formGroup]="modForm" class="d-flex justify-content-between row mx-0 p-1 w-100 text-dark">
                <div class="form-group col-md-3 col-sm-12 m-0 px-1" [ngClass]="{'col-md-6': isFlat}">
                  <label for="firstName">{{ words[language][ 'type' ] }}</label>
                      <select class="form-control form-control-sm" formControlName="identificationTypeId">
                        @for (type of identificationTypes; track type.id) {
                        <option value="{{type.id}}">{{type.type}}</option>
                        }
                      </select>
                </div>
                <div class="form-group col-md-3 col-sm-12 m-0 px-1" [ngClass]="{'col-md-6': isFlat}">
                  <label for="number">{{ words[language][ 'number' ] }}</label>
                  <input class="form-control" type="number" id="number" formControlName="number"
                    autocomplete="off">
                  @if (number.invalid && number.dirty) {
                    <span class="text-danger">{{ words[language][
                    'invalidNumber' ] }}</span>
                  }
                </div>
                <div class="form-group col-md-3 col-sm-12 m-0 px-1" [ngClass]="{'col-md-6': isFlat}">
                  <label for="issuer">{{ words[language][ 'issuer' ] }}</label>
                  <select id="issuer" class="form-control" formControlName="issuer">
                    @for (object of issuers; track object) {
                      <option [value]="object.name">{{object.name}}
                      </option>
                    }
                  </select>
                  @if (issuer.invalid && issuer.dirty) {
                    <span class="text-danger">{{ words[language][
                    'invalidIssuer' ] }}</span>
                  }
                </div>
                <div class="form-group col-md-3 col-sm-12 m-0 px-1" [ngClass]="{'col-md-6': isFlat}">
                  <label for="expiration">{{ words[language][ 'expirationDate' ] }}</label>
                  <input class="form-control" type="date" max="3000-12-31" id="expiration"
                    formControlName="expirationDate" autocomplete="off">
                  @if (expirationDate.invalid && expirationDate.dirty) {
                    <span class="text-danger">{{
                    words[language][ 'invalidExpirationDate' ] }}</span>
                  }
                </div>
                <div class="col-sm-12 d-flex align-items-center justify-content-center"
                  [ngClass]="{'col-md-6': isFlat}">
                  <button class="btn btn-success m-1" id="btn-update-identifications" (click)="update()"
                    [disabled]="!modForm.valid || loading">
                    @if (loading) {
                      <span class="spinner-grow spinner-grow-sm" role="status"></span>
                    }
                  Update</button>
                  <button class="btn btn-light m-1" (click)="resetMod()">{{ words[language][ 'cancel' ]
                  }}</button>
                </div>
              </form>
            </section>
          }
          @if (identificationList.length>0) {
            <div class="col-sm-12" [ngClass]="{'col-md-6': isFlat}">
              <table class="table table-sm table-hover table-striped table-responsive">
                <thead>
                  <tr>
                    <th>Type</th>
                    <th>Number</th>
                    <th>Issuer</th>
                    <th>Expiry Date</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  @for (identification of identificationList; track identification; let i = $index) {
                    <tr
                      class="ribbon-box border">
                      <td>{{identification.identificationType.type}}</td>
                      <td>{{ viewNumber ? identification.number : '*********'}}</td>
                      <td>{{identification.issuer}}</td>
                      <td>{{identification.expirationDate | date:'shortDate'}}</td>
                      <td>
                        <button class="btn btn-sm text-dark" (click)="viewNumber=!viewNumber">
                          @if (!viewNumber) {
                            <span>View Number</span>
                          }
                          @if (viewNumber) {
                            <span>Hide Number</span>
                          }
                        </button>
                        @if (!isFlat) {
                          <button class="btn btn-sm text-dark" data-toggle="modal"
                            title="Edit" data-target="#updateIdentificationModal"
                            (click)="selectIdentificationUpdate(identification)">
                            Edit
                          </button>
                        }
                        @if (!isFlat) {
                          <button class="btn btn-sm text-danger" data-toggle="modal"
                            title="Delete" data-target="#deleteIdentificationModal"
                            (click)="selectIdentification(identification)">
                            Delete
                          </button>
                        }
                        @if (isFlat && !identificationUpdate) {
                          <button class="btn btn-sm text-dark"
                            title="Edit" (click)="selectIdentificationUpdate(identification)">Edit
                          </button>
                        }
                        <!-- delete -->
                        @if (isFlat) {
                          <button class="btn btn-sm text-danger" title="Delete"
                            (click)="okToDelete(identification)">Delete
                          </button>
                        }
                        <button class="btn btn-sm text-dark" title="Set as Default"
                          name="'identification_'+{{identification.id}}"
                          id="'identification_'+{{identification.id}}"
                          (click)="selectDefault(identification)"
                          [ngClass]="{'d-none': identification.primary}">
                          Set as Default
                        </button>
                      </td>
                      <td>
                        @if (identification.primary) {
                          <div class="ribbon-two ribbon-two-primary"
                            >
                            <span>{{ words[language][ 'default' ] }}</span>
                          </div>
                        }
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>

<!-- ? modals -->
<div id="addIdentificationsModal" class="modal fade" data-backdrop="static" tabindex="-1" role="dialog"
  aria-labelledby="standard-modalLabel">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-light">
        <h4 class="modal-title " id="standard-modalLabel">{{ words[language][ 'addIdentification' ] }}</h4>
        <button type="button" class="close" data-dismiss="modal"
        id="close-modal-identifications">×</button>
      </div>
      <div class="modal-body">
        <!-- body -->
        <form [formGroup]="form">
          <ng-container formArrayName="ids">
            @for (identityForm of ids.controls; track identityForm; let i = $index) {
              <div>
                <div class="row mx-0" [formGroup]="identityForm">
                  <!-- firstName input-->
                  <div class="form-group col-md-3">
                    <label for="firstName">{{ words[language][ 'type' ] }}</label>
                    <select class="form-control form-control-sm" formControlName="identificationTypeId">
                      @for (type of identificationTypes; track type.id) {
                      <option value="{{type.id}}">{{type.type}}</option>
                      }
                    </select>
                  </div>
                  <!-- number input -->
                  <div class="form-group col-md-3">
                    <label for="number">{{ words[language][ 'number' ] }}</label>
                    <input class="form-control" type="number" id="number" formControlName="number"
                      autocomplete="off">
                    @if (identityForm.get('number').invalid && identityForm.get('number').dirty) {
                      <span class="text-danger"
                        >{{
                      words[language][ 'invalidNumber' ] }}</span>
                    }
                  </div>
                  <!--  Issuer  input -->
                  <div class="form-group col-md-2">
                    <label for="issuer2">{{ words[language][ 'issuer' ] }}</label>
                    <select id="issuer2" class="form-control" formControlName="issuer">
                      @for (object of issuers; track object) {
                        <option [value]="object.name">
                          {{object.name}}
                        </option>
                      }
                    </select>
                    @if (identityForm.get('issuer').invalid && identityForm.get('issuer').dirty) {
                      <span class="text-danger"
                        >{{
                      words[language][ 'invalidIssuer' ] }}</span>
                    }
                  </div>
                  <!--  Expiration Date input -->
                  <div class="form-group col-md-3 col-sm-11">
                    <label for="expiration">{{ words[language][ 'expirationDate' ] }}</label>
                    <input class="form-control" type="date" max="3000-12-31" id="expiration"
                      formControlName="expirationDate" autocomplete="off">
                    @if (identityForm.get('expirationDate').invalid && identityForm.get('expirationDate').dirty) {
                      <span class="text-danger"
                        >{{
                      words[language][ 'invalidExpirationDate' ] }}</span>
                    }
                  </div>
                  <!-- icons -->
                  <div class="col-sm-1 d-flex align-items-center justify-content-center">
                    <!-- discard -->
                    @if ((ids.length > 1) && !loading) {
                      <span class="dripicons-trash text-danger clickable" (click)="discard(i)"
                      ></span>
                    }
                  </div>
                </div>
              </div>
            }
            <button type="button" class="btn btn-success btn-sm" (click)="add($event)" id="addIdentity"><span
            class="dripicons-plus"></span> {{words[language].addAnother}}</button>
          </ng-container>
        </form>
        <div class="modal-footer">
          <!-- <div class="col-md-12 d-flex justify-content-end px-3 mt-2"> -->
          <button class="btn btn-success mr-2" id="btn-save-identifications" (click)="save()"
            [disabled]="!form.valid" [class.d-none]="isFlat">
            @if (loading) {
              <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
            }
          {{ words[language][ 'save' ] }}</button>
          <!-- cancel button -->
          <button class="btn btn-light" id="btn-cancel" data-dismiss="modal">{{ words[language][ 'cancel'
          ] }}</button>
        <!-- </div> -->
      </div>
    </div>
  </div><!-- /.modal-content -->
</div><!-- /.modal-dialog -->
</div><!-- /.modal -->

<!-- ! delete modal -->
<div class="modal fade" id="deleteIdentificationModal" data-backdrop="static" tabindex="-1" role="dialog"
  aria-labelledby="mySmallModalLabel">
  <div class="modal-dialog modal-sm modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body d-flex flex-wrap align-items-center justify-content-center">
        <span class="uil-trash-alt text-danger h1"></span>
        <h4 class="text-danger w-100 text-center">{{ words[language][ 'delete' ] }}</h4>
        <span class="text-muted my-3 text-center">{{ words[language][ 'deleteIdentifications' ] }}</span>

        <button class="btn btn-danger mt-2 mr-2" (click)="delete()" [disabled]="loading">
          @if (loading) {
            <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
          }
          {{ words[language][ 'yes' ] }}
        </button>
        <button type="button" class="btn btn-secondary mt-2" data-dismiss="modal"
        id="close-delete-modal-identification">No</button>
      </div>
    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div><!-- /.modal -->

<!-- todo: update modals -->
<div id="updateIdentificationModal" class="modal fade" data-backdrop="static" tabindex="-1" role="dialog"
  aria-labelledby="standard-modalLabel">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-light">
        <h4 class="modal-title " id="standard-modalLabel">{{ words[language][ 'updateIdentification' ] }}
        </h4>
        <button type="button" class="close" data-dismiss="modal"
        id="close-modal-update-identifications">×</button>
      </div>
      <div class="modal-body">
        <!-- body -->
        <form [formGroup]="modForm" class="d-flex p-2 justify-content-between row mx-0 w-100 ">
          <!-- firstName input-->
          <div class="form-group col-md-3 col-sm-12">
            <label for="firstName">{{ words[language][ 'type' ] }}</label>
                <select class="form-control form-control-sm" formControlName="identificationTypeId">
                  @for (type of identificationTypes; track type.id) {
                  <option value="{{type.id}}">{{type.type}}</option>
                  }
                </select>
          </div>
          <!-- number input -->
          <div class="form-group col-md-3 col-sm-12">
            <label for="number">{{ words[language][ 'number' ] }}</label>
            <input class="form-control" type="text" id="number" formControlName="number" autocomplete="off">
            @if (number.invalid && number.dirty) {
              <span class="text-danger">{{ words[language][
              'invalidNumber' ] }}</span>
            }
          </div>
          <!--  Issuer  input -->
          <div class="form-group col-md-3 col-sm-12">
            <label for="issuer">{{ words[language][ 'issuer' ] }}</label>
            <select id="issuer" class="form-control" formControlName="issuer">
              @for (object of issuers; track object) {
                <option [value]="object.name">{{object.name}}
                </option>
              }
            </select>
            @if (issuer.invalid && issuer.dirty) {
              <span class="text-danger">{{ words[language][
              'invalidIssuer' ] }}</span>
            }
          </div>
          <!--  Expiration Date input -->
          <div class="form-group col-md-3 col-sm-12">
            <label for="expiration">{{ words[language][ 'expirationDate' ] }}</label>
            <input class="form-control" type="date" max="3000-12-31" id="expiration"
              formControlName="expirationDate" autocomplete="off">
            @if (expirationDate.invalid && expirationDate.dirty) {
              <span class="text-danger">{{
              words[language][ 'invalidExpirationDate' ] }}</span>
            }
          </div>
        </form>
        <div class="modal-footer">
          <!-- <div class="col-md-12 d-flex justify-content-end px-3 mt-2"> -->
          <!-- save button -->
          <button class="btn btn-success mr-2" id="btn-update-identifications" (click)="update()"
            [disabled]="!modForm.valid || loading">
            @if (loading) {
              <span class="spinner-grow spinner-grow-sm mr-1" role="status"
              ></span>
            }Update</button>
            <!-- cancel button -->
            <button class="btn btn-light" data-dismiss="modal">{{ words[language][ 'cancel' ] }}</button>
          <!-- </div> -->
        </div>
      </div>
    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div><!-- /.modal -->